import { AdminButton } from "../AdminButton/AdminButton";

// Thin, named wrapper around AdminButton for the form-submit use case -
// not a second button implementation, just makes call sites read clearly
// (<LoadingButton loading={isSaving}>Save</LoadingButton>) without every
// form needing to know AdminButton's full prop surface.
export const LoadingButton = ({ loading = false, loadingLabel, children, ...rest }) => (
  <AdminButton loading={loading} {...rest}>
    {loading && loadingLabel ? loadingLabel : children}
  </AdminButton>
);
